/**
 * Router that will match any url to the appropriate page component.
 *
 * Will listen to generic urls that dont have a pattern (or have) will read from graphql the type of entity and map
 * to the appropriate page.
 */
import JobiqoRouterPage, { getServerSideProps } from './../jobiqo/pages/router';
export default JobiqoRouterPage;
export { getServerSideProps };
